import { batchList, activeCourseNameList, courseEnrollmentList} from "constants/batch";

const initialState = {
  batchList: {},
  activeCourseNameList: {},
  courseEnrollmentList: {},
};

const batch = (state = initialState, action) => {
  switch (action.type) {
    case batchList:
      return { ...state, batchList: action.payload };

    case activeCourseNameList:
      return { ...state, activeCourseNameList: action.payload };

    case courseEnrollmentList:
      return { ...state, courseEnrollmentList: action.payload };

    default:
      return state;
  }
};

export default batch;